/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Refresh_Success_ToastInputs */

const en_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const fr_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const de_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const it_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const ru_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const es_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const zh_cn2_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const ja_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const hi_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

const pt_pt2_explorer_search_refresh_success_toast = /** @type {(inputs: Explorer_Search_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search filters refreshed.`)
};

/**
* | output |
* | --- |
* | "Search filters refreshed." |
*
* @param {Explorer_Search_Refresh_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_refresh_success_toast = /** @type {((inputs?: Explorer_Search_Refresh_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Refresh_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_refresh_success_toast(inputs)
	if (locale === "de") return de_explorer_search_refresh_success_toast(inputs)
	if (locale === "it") return it_explorer_search_refresh_success_toast(inputs)
	if (locale === "ru") return ru_explorer_search_refresh_success_toast(inputs)
	if (locale === "es") return es_explorer_search_refresh_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_refresh_success_toast(inputs)
	if (locale === "ja") return ja_explorer_search_refresh_success_toast(inputs)
	if (locale === "hi") return hi_explorer_search_refresh_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_refresh_success_toast(inputs)
	return en_explorer_search_refresh_success_toast(inputs)
});